module.exports = __webpack_public_path__ + "static/media/29DUNON9.5c175486.jpg";